import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { WorkspaceFilters } from "../model";

export function useWorkspaceFilters() {
  const history = useHistory();
  const location = useLocation();

  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const filters: WorkspaceFilters = useMemo(
    () => ({
      q: params.get("q") ?? "",
      status: (params.get("status") ?? "").split(",").filter(Boolean)
    }),
    [params]
  );

  const push = useCallback(
    (next: URLSearchParams) => {
      history.replace({ search: next.toString() });
    },
    [history]
  );

  const setQuery = useCallback(
    (q: string) => {
      const p = new URLSearchParams(params);
      if (q) p.set("q", q);
      else p.delete("q");
      push(p);
    },
    [params, push]
  );

  const toggleStatus = useCallback(
    (value: string) => {
      const current = new Set(filters.status);
      if (current.has(value)) current.delete(value);
      else current.add(value);
      const p = new URLSearchParams(params);
      const joined = Array.from(current).join(",");
      if (joined) p.set("status", joined);
      else p.delete("status");
      push(p);
    },
    [filters.status, params, push]
  );

  return { filters, setQuery, toggleStatus };
}
